import { FormErrors, ICreateOrUpdateSurveyTemplateFormValues } from 'interfaces';
import * as Yup from 'yup';

export const CREATE_UPDATE_SURVEY_TEMPLATE_VALIDATION_SCHEMA: Yup.SchemaOf<ICreateOrUpdateSurveyTemplateFormValues> =
  Yup.object().shape({
    title: Yup.string().required(FormErrors.Required).trim(FormErrors.Required),
    desc: Yup.string(),
    visibility: Yup.string()
  });